import { useEffect, useState } from 'react';
import { TriggerFieldInputProps } from '../types';
import Select, { MultiValue, SingleValue } from 'react-select';

type SelectOption = {
    label: string;
    value: string;
};

const SelectField = ({ option, id, value, onChange }: TriggerFieldInputProps) => {
    const [selectOptions, setSelectOptions] = useState<Record<string, string> | null>(
        option.options || null,
    );

    const options = Object.entries(selectOptions || {}).map(([key, value]) => ({
        value: key,
        label: value,
    })) as SelectOption[];

    const onSelectChange = (values: MultiValue<SelectOption> | SingleValue<SelectOption>) => {
        if (values) {
            if (Array.isArray(values)) {
                onChange(
                    option.id,
                    (values as SelectOption[]).map((v) => v.value),
                );
            } else {
                onChange(option.id, (values as SelectOption).value);
            }
        }
    };

    const selectedOption =
        // Multiselect options like Slack reminder weekdays will return an array of days (strings)
        // so we have to check for values that are arrays.
        Array.isArray(value)
            ? (value.map((v) => {
                  return options.find((o) => o.value === v);
              }) as MultiValue<SelectOption>)
            : options.find((o) => o.value === value);

    useEffect(() => {
        const load = async () => {
            setSelectOptions({});
        };

        if (option.optionsRemote) {
            void load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Select
            className="react-select-container"
            classNamePrefix="react-select"
            inputId={id + option.id}
            value={selectedOption}
            onChange={onSelectChange}
            options={options}
            isMulti={option.type === 'MultiSelect'}
            menuPortalTarget={document.querySelector('.automate-root') as HTMLElement}
            menuPosition="fixed"
            menuPlacement="auto"
        />
    );
};

export default SelectField;
